



















































































































































































import mixins from 'vue-typed-mixins';
import AuthUtils from './utils/AuthUtils';
import SurveyNavigation from '@/components/survey/report/SurveyNavigation.vue';
import WorksheetNavigation from '@/components/worksheet/WorksheetNavigation.vue';
import UserAgreementModal from '@/components/user/UserAgreementModal.vue';
export default mixins().extend({
  components: {
    SurveyNavigation,
    WorksheetNavigation,
    UserAgreementModal,
  },

  computed: {
    sidenav() {
      return {
        common: [
          {
            text: this.$tc('navigation.dashboard'),
            icon: 'mdi-home',
            to: { name: 'dashboard' },
            children: [],
          },
          {
            text: this.$tc('navigation.contactus'),
            icon: 'mdi-card-account-phone',
            to: { name: 'contact-info'},
            children: []
          },
          // {
          //   text: this.$tc('navigation.documents', 2),
          //   icon: 'mdi-folder',
          //   to: { name: 'dashboard' },
          //   children: [],
          // },
          // {
          //   text: this.$tc('navigation.help'),
          //   icon: 'mdi-help-circle',
          //   to: { name: 'dashboard' },
          //   children: [],
          // },
          // {
          //   text: this.$tc('navigation.contactus'),
          //   icon: 'mdi-email',
          //   to: { name: 'dashboard' },
          //   children: [],
          // },
        ],
        admin: [
          {
            text: this.$tc('model.user.label', 2),
            icon: 'mdi-account-circle',
            to: { name: 'user' },
          },
          {
            text: this.$tc('model.role.label', 2),
            icon: 'mdi-account-tie-hat',
            to: { name: 'role' },
          },
          {
            type: 'divider',
          },
          {
            text: this.$tc('model.oversightOrganization.label', 2),
            icon: 'mdi-alpha-o-circle',
            to: { name: 'oversight' },
          },
          {
            text: this.$tc('model.serviceProvider.label', 2),
            icon: 'mdi-alpha-s-circle',
            to: { name: 'provider' },
          },
          {
            text: this.$tc('model.functionalcenter.label', 2),
            icon: 'mdi-code-braces-box',
            to: { name: 'functional-center' },
          },
          {
            text: this.$tc('model.survey.label', 2),
            icon: 'mdi-file-document-edit',
            to: { name: 'survey-management' },
          },
          {
            type: 'divider',
          },
          {
            text: this.$tc('model.email.label', 2),
            icon: 'mdi-email-multiple',
            to: { name: 'email' },
          },
          {
            text: this.$tc('model.resource.label', 2),
            icon: 'mdi-help-box',
            to: { name: 'resources' },
          },
          {
            text: this.$tc('model.dataset.label', 2),
            icon: 'mdi-database',
            to: { name: 'dataset' },
          },
          {
            text: this.$tc('model.useragreement.label', 2),
            icon: 'mdi-license',
            to: { name: 'useragreement' },
          },
          {
            text: this.$tc('model.notification.label', 2),
            icon: 'mdi-message-alert',
            to: { name: 'notification' },
          },
          {
            text: this.$tc('model.log.label', 2),
            icon: 'mdi-notebook',
            to: { name: 'logs' },
          },
          {
            text: this.$tc('navigation.deployment'),
            icon: 'mdi-git',
            to: { name: 'deployment' },
          },
        ],
      };
    },
  },

  mounted() {
    // set the confirmation function onto the root scope (which is accessed through the this.$confirm(() global mixin)
    (this.$root as any)._oziConfirmFunction = this.confirm;
  },

  methods: {
    async dashboard() {
      if (this.$route.name !== 'dashboard') {
        await this.$router.push({ name: 'dashboard' });
      }
    },

    async profile() {
      if (this.$route.name !== 'profile-details') {
        await this.$router.push({ name: 'profile-details' });
      }
    },

    async logout() {
      if (this.$route.name !== 'login') {
        await AuthUtils.clear();
        await this.$router.push({ name: 'login' });
      }
    },

    async role() {
      if (this.$route.name !== 'role-select') {
        await AuthUtils.set({ role: null });
        await this.$router.push({ name: 'role-select' });
      }
    },

    async confirm(message: string, callback?: Function) {
      return await (this.$refs.confirm as any).open(message, callback);
    },
  },
});
